import axios from 'axios'
import { useState, useEffect } from 'react';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit, AiOutlinePlus } from 'react-icons/ai';
import ToastNotification from '../../../components/ToastNotification';
import { CiEdit } from "react-icons/ci";


function Deperecaition_Method() {
 const [showForm, setShowForm] = useState(false);
 const [isEditMode, setIsEditMode] = useState(false);
 const [editingCompanyId, setEditingCompanyId] = useState(null);
 const[method,setMethod] = useState([]);
  const [form, setForm] = useState({
   dep_name:'',
   dep_description:'',
  
  })
  const [searchTerm, setSearchTerm] = useState('');

  const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
  const showToast = (msg, bg = 'success') => {
    setToast({ show: true, message: msg, bg });
  };

  
const[message,setMessage] = useState([]);
    const handleAddClick = () => {
    setShowForm(true);
  };



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
      e.preventDefault();

        if (isEditMode) {
      const sendData = new FormData();

      sendData.append(" dep_name", form. dep_name);
      sendData.append("dep_description", form.dep_description);
     
     
      try {
        const res = await axios.put(
          `https://api.skyguard.group/api/update-deprecaition-method/${form.id}`,
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Method updated successfully!', 'success');
        setShowForm(false);

        fetchMethod();
        setForm({
          dep_name:'',
        dep_description:'',
       
        })
      } catch (err) {
        showToast('Fail to update method!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    } else {
      const sendData = new FormData();

    sendData.append(" dep_name", form. dep_name);
      sendData.append("dep_description", form.dep_description);

      try {
        const res = await axios.post(
          "https://api.skyguard.group/api/add-deprecaition-method",
          sendData,
          { headers: { "Content-Type": "application/json", } }
        );


        showToast('Method Added successfully!', 'success');
        setShowForm(false);
         fetchMethod();

        setForm({
           dep_name:'',
        dep_description:'',
        })
      } catch (err) {
        showToast('Fail to add  method!', 'danger');
        console.error("❌ Error:", err.response?.data || err.message);
      }
    }

  }

   const handleEdit = (form) => {
    setForm({
      id: form.id || '',
      dep_name: form.dep_name || '',
      dep_description: form.dep_description || '',
     
    });
    setEditingCompanyId(form.id);
    setIsEditMode(true);
    setShowForm(true);
  };

  
   const fetchMethod = async () => {
    try {
      const res = await axios.get("https://api.skyguard.group/api/fetch-method");
      setMethod(res.data);

    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

    useEffect(() => {
    fetchMethod();
    
  }, []);

    const filteredData = method.filter(itm =>
    Object.values(itm).some(val =>
      String(val).toLowerCase().includes(searchTerm.toLowerCase())
    )
  )
  return (

      <div className='main-section'>
         <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

              <ToastNotification
          show={toast.show}
          message={toast.message}
          bg={toast.bg}
          onClose={() => setToast({ ...toast, show: false })}
        />
         <h3 className='my-3 fw-bold fs-5 golos'>Depreciation Method</h3>
          <div className="mb-3 d-flex flex-wrap align-items-end justify-content-between">

          <div className="mb-2 w-50 w-md-50 pe-md-2">
            <input
              className="form-control w-100"
              list="datalistOptions"
              placeholder="Search ...."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>

          <div className="mb-2">
            <button className="btn btn-success" onClick={handleAddClick}>
              <AiOutlinePlusCircle size={20} /> Add
            </button>
          </div>
        </div>
  {showForm && (


          <div className='card p-3 mb-3  w-75 mx-auto'>
            <form onSubmit={handleSubmit} >
              <hr />

              <div className='row g-3'>

                <div className="col-md-6">
                  <label htmlFor='name' className="form-label fw-medium" > Name</label>
                  <input type="text" className="form-control" name="dep_name" placeholder="Enter here..." value={form.dep_name} onChange={handleInputChange} required />
                </div>

                <div className="col-md-6">
                  <label htmlFor='middle' className="form-label fw-medium" >Description</label>
                  <textarea 
                   type='text'
                   name='dep_description'
                   value={form.dep_description}
                   className='form-control'
                   rows={6}
                   onChange={handleInputChange} required
                  />
                </div>
           
             

            
                <div className='gap-2 d-flex justify-content-center mt-4'>
                  <button type="submit" className='btn btn-success w-10'>
                    {isEditMode ? "Update" : "Save"}
                  </button>
                  <button type='button' className='btn btn-danger w-10 ms-2' onClick={() => {
                    setShowForm(false);
                    setIsEditMode(false);
                    setForm({
                       dep_name:'',
                         dep_description:'',
                   
                    })
                  }}>
                    Cancel
                  </button>
                </div>

              </div>
            </form>
          </div>
        )}


   <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
     <table className='table table-bordered table-striped table-hover text-center align-middle'>
       <thead className='table-info'>
              <tr>
                <th scope='col'>SN</th>
                <th scope='col'>Name</th>
                <th scope='col'>Description</th>
                <th scope='col'>Action</th>
              </tr>
            </thead>
     <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((c, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td >{c.dep_name}</td>
                    <td className='text-wrap'>{c.dep_description}</td>
                   
                    <td>
                      <button className='btn btn-sm btn-primary mx-1' onClick={() => handleEdit(c)}><AiOutlineEdit size={18} />

                      </button>
                    
                    </td>
                  </tr>
                ))) : (
                <tr>
                  <td colSpan="8" className="text-center text-danger fw-bold text-muted">No data found</td>
                </tr>
              )}
            </tbody>
        </table>
     </div>

            </div>
        </div>
  )
}

export default Deperecaition_Method